export default (episodeId) => {
  // document.getElementById(episodeId).scrollIntoView({ block: 'center' })
  const offsetTop = document.getElementById(episodeId).offsetTop
  const visibleHeight = window.innerHeight - 45 - 145 // substract filter and controls heights
  const episodHeight = 46
  window.scrollTo(0, offsetTop - visibleHeight / 2 - episodHeight / 2)
}
